import './Tag.scss';
import React from 'react';


class Tag extends React.Component {
  render() {
    const labelClasses =
        'label ' + (this.props.darkText ? 'darkText' : 'lightText');
    return (
      <div className={'Tag ' + this.props.className}>
        <div className={labelClasses}>
          {this.props.label}
        </div>
      </div>
    );
  }
}


export default Tag;
